module.exports = __webpack_public_path__ + "static/product-l0950-coyote-tan-6247d38b634a3cddcb9118902fe114bb.png";